const id = (): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%&*-'
  const charactersLength = characters.length
  let ID = ''

  for (let i = 0; i < 30; i++) {
    ID += characters.charAt(Math.floor(Math.random() * charactersLength))
  }

  return ID
}

export default id
